import React from "react";
import { toast } from "react-toastify";

const options = {
  autoClose: 2000,
  hideProgressBar: false,
  position: toast.POSITION.BOTTOM_RIGHT,
  pauseOnHover: true,
};

const stringifyMessage = (message) => {
  if (typeof message === "string") return message;
  if (message == null) return "";
  try {
    return JSON.stringify(message, null, 2);
  } catch (error) {
    return String(message);
  }
};

const ErrorToast = ({ message }) => {
  const text = stringifyMessage(message);
  const [copied, setCopied] = React.useState(false);

  const handleCopy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (error) {
      // silent
    }
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 6,
          fontWeight: 600,
          fontSize: 13,
        }}
      >
        <span>Error</span>
        <button
          type="button"
          onClick={handleCopy}
          style={{
            border: "1px solid rgba(255,255,255,0.35)",
            background: copied ? "rgba(255,255,255,0.15)" : "transparent",
            color: "inherit",
            borderRadius: 6,
            padding: "2px 10px",
            cursor: "pointer",
            fontSize: 11,
            fontWeight: 600,
            lineHeight: 1.5,
            flexShrink: 0,
            marginLeft: 8,
          }}
        >
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
      <div
        style={{
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          maxHeight: 180,
          overflow: "auto",
          fontSize: 12,
          lineHeight: 1.45,
        }}
      >
        {text}
      </div>
    </div>
  );
};

const myToast = {
  success: (message) => {
    toast.success(message, options);
  },
  info: (message) => {
    toast.info(message, options);
  },
  error: (message) => {
    toast.error(<ErrorToast message={message} />, {
      ...options,
      autoClose: 20000,
      closeOnClick: false,
    });
  },
  warning: (message) => {
    toast.warn(message, options);
  },
};

export default myToast;
